module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('img', {
    attrs: {
      "src": "/static/help/artistslist.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "size": "mini"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" Pomocnicze informacje dotyczące grafik\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tło (motyw)",
      "error": _vm.errors.image
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.image),
      callback: function($$v) {
        _vm.$set(_vm.form, "image", $$v)
      },
      expression: "form.image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Film w tle",
      "error": _vm.errors.background_video
    }
  }, [_c('file-input-component', {
    model: {
      value: (_vm.form.background_video),
      callback: function($$v) {
        _vm.$set(_vm.form, "background_video", $$v)
      },
      expression: "form.background_video"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-form-group"
  }, [_c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition,
      "required": true
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tagi",
      "error": _vm.errors.tags
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "Tagi"
    },
    model: {
      value: (_vm.form.tags),
      callback: function($$v) {
        _vm.$set(_vm.form, "tags", $$v)
      },
      expression: "form.tags"
    }
  }, _vm._l((_vm.availableTags), function(tag) {
    return _c('el-option', {
      key: tag.id,
      attrs: {
        "label": tag.name,
        "value": tag.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Sortowanie alfabetyczne"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.alphabetical_order),
      callback: function($$v) {
        _vm.$set(_vm.form, "alphabetical_order", $$v)
      },
      expression: "form.alphabetical_order"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Doładowuj"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Limit na start"
    },
    model: {
      value: (_vm.form.page_size),
      callback: function($$v) {
        _vm.$set(_vm.form, "page_size", $$v)
      },
      expression: "form.page_size"
    }
  }), _vm._v(" "), _c('small', [_vm._v("Doładowywanie każdorazowo tyle elementów ile wynosi \"limit na start\"")])], 1)], 1), _vm._v(" "), _c('artists-preview', {
    attrs: {
      "form": _vm.form
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04c9db3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/ArtistsListWidget/ArtistsListWidget.vue
// module id = 711
// module chunks = 0